import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import React from 'react';
import {useCallback} from 'react';

import {
    custFirmChoices,
    openCloseChoices
} from '../../resources/tradeSummary.resource';
import {mapApiValue} from '../../utils/utilities';

const useStyles = makeStyles((theme: any) => ({
    deleteBtn: {
        color: '#c9001a'
    }
}));

const AgDeleteBtn = (props) => {
    const classes = useStyles(props);
    const onClick = useCallback(() => {
        props.context.onClick(props);
    }, [props]);
    return (
        <IconButton
            data-e2e-tag='tradeSplitDeleteBtn'
            data-modal-name='tradeSplit'
            color='secondary'
            className={classes.deleteBtn}
            onClick={onClick}>
            <DeleteOutlineOutlinedIcon />
        </IconButton>
    );
};

const deleteBtn = {
    field: 'delete',
    pinned: 'right',
    suppressToolPanel: true,
    movable: false,
    resizable: false,
    suppressSizeToFit: true,
    headerName: '',
    valueGetter: ({data}) => data,
    minWidth: 50,
    width: 50,
    cellRendererFramework: AgDeleteBtn
};

const rowNumber = {
    headerName: 'Row #',
    pinned: 'left',
    valueGetter: 'node.rowIndex + 1'
};

export const tradeSplitOneSideColumnDefs = [
    deleteBtn,
    rowNumber,
    {
        field: 'execQty',
        headerName: 'Slice Quantity',
        type: 'number'
    },
    {
        field: 'reasonCode',
        headerName: 'Change Reason'
    },

    {
        field: 'custFirmId',
        headerName: 'MPID'
    },
    {
        field: 'custOpenClose',
        headerName: 'Open/Close',
        valueGetter: ({data}) =>
            mapApiValue(data, 'custOpenClose', openCloseChoices)
    },
    {
        field: 'custFirm',
        headerName: 'Customer or Firm',
        valueGetter: ({data}) => mapApiValue(data, 'custFirm', custFirmChoices)
    },
    {
        field: 'custSndrSubId',
        headerName: 'MMID'
    },
    {
        field: 'custClearingNumber',
        headerName: 'Clearing #'
    },
    {
        field: 'custSubmittingBkrId',
        headerName: 'Badge'
    },
    {
        field: 'custCmta',
        headerName: 'CMTA'
    },
    {
        field: 'custAccount',
        headerName: 'Account'
    },
    {
        field: 'custOptnlData',
        headerName: 'Optional Data'
    }
];

export const tradeSplitBothSideColumnDefs = [
    deleteBtn,
    rowNumber,
    {
        field: 'execQty',
        headerName: 'Slice Quantity',
        type: 'number'
    },
    {
        field: 'reasonCode',
        headerName: 'Change Reason'
    },

    {
        field: 'custFirmId',
        headerName: 'Customer side: MPID'
    },
    {
        field: 'custOpenClose',
        headerName: 'Customer side: Open/Close',
        valueGetter: ({data}) =>
            mapApiValue(data, 'custOpenClose', openCloseChoices)
    },
    {
        field: 'custFirm',
        headerName: 'Customer side: Customer or Firm',
        valueGetter: ({data}) => mapApiValue(data, 'custFirm', custFirmChoices)
    },
    {
        field: 'custSndrSubId',
        headerName: 'Customer side: MMID'
    },
    {
        field: 'custClearingNumber',
        headerName: 'Customer side: Clearing #'
    },
    {
        field: 'custSubmittingBkrId',
        headerName: 'Customer side: Badge'
    },
    {
        field: 'custCmta',
        headerName: 'Customer side: CMTA'
    },
    {
        field: 'custAccount',
        headerName: 'Customer side: Account'
    },
    {
        field: 'custOptnlData',
        headerName: 'Customer side: Optional Data'
    },
    {
        field: 'contraOrdFirmId',
        headerName: 'Contra side: MPID'
    },
    {
        field: 'contraOrdOpenClose',
        headerName: 'Contra side: Open/Close',
        valueGetter: ({data}) =>
            mapApiValue(data, 'contraOrdOpenClose', openCloseChoices)
    },
    {
        field: 'contraOrdCustFirm',
        headerName: 'Contra side: Customer or Firm',
        valueGetter: ({data}) =>
            mapApiValue(data, 'contraOrdCustFirm', custFirmChoices)
    },
    {
        field: 'contraOrdSndrSubId',
        headerName: 'Contra side: MMID'
    },
    {
        field: 'contraOrdClearingNumber',
        headerName: 'Contra side: Clearing #'
    },
    {
        field: 'contraOrdSubmittingBkrId',
        headerName: 'Contra side: Badge'
    },
    {
        field: 'contraOrdCmta',
        headerName: 'Contra side: CMTA'
    },
    {
        field: 'contraOrdAccount',
        headerName: 'Contra side: Account'
    },
    {
        field: 'contraOrdOptnlData',
        headerName: 'Contra side: Optional Data'
    }
];
